
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-studio/general-models",
      function () {
        return require("private-next-pages/customer-studio/general-models.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-studio/general-models"])
      });
    }
  